// default breadcrumb
export const BREADCRUMB_DATA = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class.",
  },
];

//Divider Breadcrumbs
export const DIVIDER_BREADCRUMB = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb-icon",
  },
  {
    text: " class.",
  },
];

//With Icons Breadcrumbs
export const WITH_ICONS_BREADCRUMB = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class.",
  },
];

//Variation Of Breadcrumbs
export const VARIATION_OF_BREADCRUMB = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: "class through any icons sets.",
  },
];

//Colored Breadcrumbs
export const COLOURED_BREADCRUMB = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class and set background colors like ",
    code: "[.bg-*].",
  },
];

export const COLOURED_BREADCRUMB_LIST = [
  {
    className: "m-b-30 bg-secondary",
    span: [
      {
        title: "Home",

      },
      {
        title: "Icons",

      },
      {
        activeTitle: "Flag-icon",
      },
    ],
  },
  {
    className: "m-0 bg-success",
    span: [
      {
        title: "Home",

      },
      {
        title: "Gallery",

      },
      {
        activeTitle: "Gallery-grid",
      },
    ],
  },
];
